import { render, staticRenderFns } from "./logNotifications.vue?vue&type=template&id=7ea50455&scoped=true&"
import script from "./logNotifications.vue?vue&type=script&lang=js&"
export * from "./logNotifications.vue?vue&type=script&lang=js&"
import style0 from "./logNotifications.vue?vue&type=style&index=0&id=7ea50455&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea50455",
  null
  
)

export default component.exports